
export type StreamingInfoResponseDrmType = typeof StreamingInfoResponseDrmType[keyof typeof StreamingInfoResponseDrmType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StreamingInfoResponseDrmType = {
  none: 'none',
  fairplay: 'fairplay',
  widevine: 'widevine',
  playready: 'playready',
} as const;
